import { ReferenceType } from '../../../../../../../../../../../backend/src/types/types';

export interface ReferenceTypeStyle {
  // Human-readable label used in the legend (e.g. "Thread files").
  label: string;
  // Rest-state classes applied to the reference chip and the side-panel tab.
  chip: string;
  // Hover-state classes applied to the chip when it's clickable.
  chipHover: string;
  // Filled box used in the legend (a stronger shade than `chip`).
  legendBox: string;
  // Text colour used in the legend label.
  legendText: string;
}

export const REFERENCE_TYPE_STYLES: Record<ReferenceType, ReferenceTypeStyle> = {
  [ReferenceType.Fact]: {
    label: 'Facts',
    chip: 'border-blue-300 bg-blue-50 text-blue-500',
    chipHover: 'hover:border-blue-400 hover:bg-blue-100 hover:text-blue-600',
    legendBox: 'border-blue-400 bg-blue-100',
    legendText: 'text-blue-950',
  },
  [ReferenceType.Chunk]: {
    label: 'Chunks',
    chip: 'border-orange-300 bg-orange-50 text-orange-500',
    chipHover: 'hover:border-orange-400 hover:bg-orange-100 hover:text-orange-600',
    legendBox: 'border-orange-400 bg-orange-100',
    legendText: 'text-orange-950',
  },
  [ReferenceType.Document]: {
    label: 'Documents',
    chip: 'border-purple-300 bg-purple-50 text-purple-500',
    chipHover: 'hover:border-purple-400 hover:bg-purple-100 hover:text-purple-600',
    legendBox: 'border-purple-400 bg-purple-100',
    legendText: 'text-purple-950',
  },
  [ReferenceType.ThreadFileChunk]: {
    label: 'Files',
    chip: 'border-gray-400 bg-gray-200/70 text-gray-700',
    chipHover: 'hover:border-gray-500 hover:bg-gray-200 hover:text-gray-800',
    legendBox: 'border-gray-400 bg-gray-200',
    legendText: 'text-gray-950',
  },
  [ReferenceType.ThreadFile]: {
    label: 'Files',
    chip: 'border-gray-400 bg-gray-200/70 text-gray-700',
    chipHover: 'hover:border-gray-500 hover:bg-gray-200 hover:text-gray-800',
    legendBox: 'border-gray-400 bg-gray-200',
    legendText: 'text-gray-950',
  },
  [ReferenceType.Entity]: {
    label: 'Entities',
    chip: 'border-green-300 bg-green-50 text-green-500',
    chipHover: 'hover:border-green-400 hover:bg-green-100 hover:text-green-600',
    legendBox: 'border-green-400 bg-green-100',
    legendText: 'text-green-950',
  },
};

// Order of types shown in the legend. Excludes Entity since entity references
// aren't surfaced as clickable chips today.
export const LEGEND_REFERENCE_TYPES: ReferenceType[] = [
  ReferenceType.Fact,
  ReferenceType.Chunk,
  ReferenceType.Document,
  ReferenceType.ThreadFileChunk,
];
